import { createSelector } from 'reselect';
 
const selectChannels = (state: any) => state.channels;
 
export const selectCurrentItem = createSelector([selectChannels], (channels) => channels.current);
 
export const selectChannelListItems = createSelector([selectChannels], (channels) => channels.list);
 
 
export const selectItemById = (itemId: any) =>
    createSelector(selectChannelListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectChannelsQueryItems = createSelector([selectChannels], (channels) => channels.query);
export const selectCreatedItem = createSelector([selectChannels], (channels) => channels.create);
 
export const selectUpdatedItem = createSelector([selectChannels], (channels) => channels.update);
 
export const selectReadItem = createSelector([selectChannels], (channels) => channels.read);
 
export const selectDeletedItem = createSelector([selectChannels], (channels) => channels.delete);
 
export const selectSearchedItems = createSelector([selectChannels], (channels) => channels.search);
 
export const selectItemsCount = createSelector([selectChannels], (channels) => channels.count);
 
export const selectItemsFilter = createSelector([selectChannels], (channels) => channels.filter);